var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrupo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 238.241,
    height: 274.015,
    viewBox: "0 0 238.241 274.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_292",
    "data-name": "Grupo 292",
    transform: "translate(-3563.75 -403.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_278",
    "data-name": "Grupo 278",
    transform: "translate(3614.274 510.928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_277",
    "data-name": "Grupo 277",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_276",
    "data-name": "Grupo 276",
    transform: "translate(9.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_400",
    "data-name": "Caminho 400",
    d: "M3984.563,973.885h-40.235a68.657,68.657,0,0,1-11.812-1,141.289,141.289,0,0,0-18.783-1.492,1.8,1.8,0,0,1,.016-3.6h.017a142.181,142.181,0,0,1,19.371,1.546,65.048,65.048,0,0,0,11.191.944h40.235a10.73,10.73,0,0,0,10.719-10.718V913.742a10.718,10.718,0,0,0-10.72-10.718l-28.074,0a1.8,1.8,0,0,1-1.178-3.157c.112-.1,11.313-9.965,13.332-22.491a122.142,122.142,0,0,0,1.38-13.273,8.446,8.446,0,0,0-16.755-1.9c-1.615,9.1-5.02,20.992-12.066,25.991a74.466,74.466,0,0,1-6.334,3.994c-3.184,1.836-4.119,2.444-4.508,4.2-2.51,11.382-8.48,18.843-16.809,21.006a1.8,1.8,0,0,1-.9-3.48c4.919-1.278,11.376-5.49,14.2-18.3.748-3.385,2.926-4.641,6.222-6.542a71.384,71.384,0,0,0,6.05-3.812c4.723-3.35,8.489-11.763,10.606-23.687a12.042,12.042,0,0,1,23.887,2.709,125.669,125.669,0,0,1-1.422,13.665c-1.528,9.484-7.55,17.336-11.35,21.478l23.719,0h0a14.314,14.314,0,0,1,14.314,14.314v45.829A14.33,14.33,0,0,1,3984.563,973.885Z",
    transform: "translate(-3888.471 -851.617)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_401",
    "data-name": "Caminho 401",
    d: "M3822.536,1159.623a5.973,5.973,0,0,1-5.774-6.057l-.687-56.557a5.966,5.966,0,0,1,5.68-6.214l14.2-.253a5.971,5.971,0,0,1,5.857,6.057l.687,56.557a6.312,6.312,0,0,1-1.574,4.3,5.557,5.557,0,0,1-4.106,1.913l-14.2.253h-.083Zm.051-1.8h0Zm13.45-63.688h-.026l-14.2.253a2.382,2.382,0,0,0-2.142,2.571l.688,56.557a2.386,2.386,0,0,0,2.179,2.508h.023l14.2-.254a2,2,0,0,0,1.476-.707,2.73,2.73,0,0,0,.666-1.864l-.687-56.557A2.386,2.386,0,0,0,3836.037,1094.137Z",
    transform: "translate(-3816.073 -1033.263)",
    fill: "#037cf9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_402",
    "data-name": "Caminho 402",
    d: "M3786.127,1124.6H3776.3a1.8,1.8,0,0,1,0-3.6h9.829a1.8,1.8,0,0,1,0,3.6Z",
    transform: "translate(-3774.5 -1056.42)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_403",
    "data-name": "Caminho 403",
    d: "M3786.127,1340.6H3776.3a1.8,1.8,0,0,1,0-3.6h9.829a1.8,1.8,0,0,1,0,3.6Z",
    transform: "translate(-3774.5 -1220.638)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_404",
    "data-name": "Caminho 404",
    d: "M4010.448,1107.953a1.8,1.8,0,0,1-.69-3.459l3.537-1.468a25.081,25.081,0,0,0,15.51-23.231v-26.953a1.8,1.8,0,1,1,3.6,0V1079.8a28.667,28.667,0,0,1-17.728,26.552l-3.537,1.468A1.792,1.792,0,0,1,4010.448,1107.953Z",
    transform: "translate(-3952.516 -1003.235)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_405",
    "data-name": "Caminho 405",
    d: "M4129.939,1252.279a1.8,1.8,0,0,1-.437-.054l-.047-.012a16.132,16.132,0,0,1-11.766-15.492v-17.127a1.8,1.8,0,0,1,3.6,0v17.127a12.524,12.524,0,0,0,9.129,12.026,1.8,1.8,0,0,1-.475,3.532Z",
    transform: "translate(-4035.415 -1130.01)",
    fill: "#037cf9"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_406",
    "data-name": "Caminho 406",
    d: "M4297.658,940.909a1.8,1.8,0,0,1-1.725-1.292c-.237-.806-2.567-4.039-6.41-6.543-.583-.38-1.217-.76-1.888-1.162-3.82-2.29-9.052-5.427-9.005-12.051.044-6.367,3.384-11.152,8.509-12.191a9.826,9.826,0,0,1,6.893,1.188,11.871,11.871,0,0,1,3.606,3.315,10.6,10.6,0,0,1,10.562-4.366c5.09,1.025,8.408,5.728,8.451,11.982.045,6.383-4.723,9.333-8.554,11.7-.82.508-1.6.987-2.286,1.474-3.683,2.595-6.2,5.84-6.412,6.594a1.8,1.8,0,0,1-1.71,1.349Zm-8.608-29.836a6.01,6.01,0,0,0-1.2.121c-3.387.686-5.6,4.1-5.627,8.692-.032,4.571,3.674,6.793,7.258,8.942.7.42,1.363.817,2,1.234a28.142,28.142,0,0,1,6.188,5.6,30.981,30.981,0,0,1,6.065-5.63c.779-.549,1.636-1.079,2.466-1.593,3.538-2.189,6.88-4.257,6.849-8.62-.038-5.435-2.9-7.945-5.565-8.482-3.81-.768-6.866,2.045-8.205,5.173a1.8,1.8,0,0,1-1.651,1.09h0a1.8,1.8,0,0,1-1.651-1.087C4294.511,913.1,4291.876,911.073,4289.05,911.073Z",
    transform: "translate(-543.499 -383.161)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_279",
    "data-name": "Grupo 279",
    transform: "translate(3563.75 505.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_407",
    "data-name": "Caminho 407",
    d: "M3585.993,873.865a22.243,22.243,0,1,1,22.243-22.243A22.268,22.268,0,0,1,3585.993,873.865Zm0-40.89a18.647,18.647,0,1,0,18.647,18.647A18.668,18.668,0,0,0,3585.993,832.975Z",
    transform: "translate(-3563.75 -829.379)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_139",
    "data-name": "Elipse 139",
    cx: 6.409,
    cy: 7.649,
    rx: 6.409,
    ry: 7.649,
    transform: "translate(15.834 21.02)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_140",
    "data-name": "Elipse 140",
    cx: 2.798,
    cy: 2.798,
    r: 2.798,
    transform: "translate(9.807 17.551) rotate(-45)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_141",
    "data-name": "Elipse 141",
    cx: 2.798,
    cy: 2.798,
    r: 2.798,
    transform: "translate(26.978 16.036) rotate(-22.5)",
    fill: "#037cf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_280",
    "data-name": "Grupo 280",
    transform: "translate(3624.598 446.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_408",
    "data-name": "Caminho 408",
    d: "M3841.836,633.265A24.269,24.269,0,1,1,3866.106,609,24.3,24.3,0,0,1,3841.836,633.265Zm0-44.943A20.673,20.673,0,1,0,3862.51,609,20.7,20.7,0,0,0,3841.836,588.322Z",
    transform: "translate(-3817.567 -584.726)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_409",
    "data-name": "Caminho 409",
    d: "M3893.05,709.569a8.13,8.13,0,0,1-8.12-8.12v-1.681a1.8,1.8,0,0,1,3.6,0v1.681a4.524,4.524,0,1,0,9.049,0v-1.681a1.8,1.8,0,1,1,3.6,0v1.681A8.129,8.129,0,0,1,3893.05,709.569Z",
    transform: "translate(-3868.781 -670.822)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_142",
    "data-name": "Elipse 142",
    cx: 2.798,
    cy: 2.798,
    r: 2.798,
    transform: "translate(13.036 16.865)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_143",
    "data-name": "Elipse 143",
    cx: 2.798,
    cy: 2.798,
    r: 2.798,
    transform: "translate(29.906 16.865)",
    fill: "#037cf9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_410",
    "data-name": "Caminho 410",
    d: "M4185.144,612.043a19.716,19.716,0,1,1,19.716-19.716A19.738,19.738,0,0,1,4185.144,612.043Zm0-35.836a16.12,16.12,0,1,0,16.12,16.12A16.138,16.138,0,0,0,4185.144,576.207Z",
    transform: "translate(-457.436 -128.57)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_281",
    "data-name": "Grupo 281",
    transform: "translate(3567.139 472.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_411",
    "data-name": "Caminho 411",
    d: "M3785.641,810.762a1.791,1.791,0,0,1-.884-.234l-31.875-18.036a1.8,1.8,0,0,1,1.771-3.129l31.874,18.036a1.8,1.8,0,0,1-.887,3.363Z",
    transform: "translate(-3710.237 -765.502)",
    fill: "#037cf9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_412",
    "data-name": "Caminho 412",
    d: "M3650.859,734.5a1.791,1.791,0,0,1-.884-.234l-18.741-10.6a1.8,1.8,0,0,1,1.771-3.13l18.741,10.6a1.8,1.8,0,0,1-.887,3.363Z",
    transform: "translate(-3617.751 -713.17)",
    fill: "#037cf9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_413",
    "data-name": "Caminho 413",
    d: "M3583.537,696.349a1.79,1.79,0,0,1-.884-.234l-3.853-2.18a1.8,1.8,0,1,1,1.771-3.13l3.853,2.18a1.8,1.8,0,0,1-.887,3.363Z",
    transform: "translate(-3577.887 -690.572)",
    fill: "#037cf9",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_414",
    "data-name": "Caminho 414",
    d: "M4098.8,560.727a1.8,1.8,0,0,1-1.8-1.8V515.3a1.8,1.8,0,0,1,3.6,0v43.631A1.8,1.8,0,0,1,4098.8,560.727Z",
    transform: "translate(-405.412 -83.629)",
    fill: "#037cf9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_415",
    "data-name": "Caminho 415",
    d: "M4098.8,418.124a1.8,1.8,0,0,1-1.8-1.8V405.3a1.8,1.8,0,0,1,3.6,0v11.028A1.8,1.8,0,0,1,4098.8,418.124Z",
    transform: "translate(-405.412)",
    fill: "#037cf9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_416",
    "data-name": "Caminho 416",
    d: "M4534.927,643.379a1.8,1.8,0,0,1-1.091-3.228l2.252-1.717a1.8,1.8,0,1,1,2.18,2.86l-2.252,1.717A1.787,1.787,0,0,1,4534.927,643.379Z",
    transform: "translate(-736.986 -178.333)",
    fill: "#037cf9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_417",
    "data-name": "Caminho 417",
    d: "M4348.42,710.483a1.8,1.8,0,0,1-1.09-3.229l33.28-25.313a1.8,1.8,0,1,1,2.177,2.862l-33.28,25.313A1.791,1.791,0,0,1,4348.42,710.483Z",
    transform: "translate(-595.191 -211.41)",
    fill: "#037cf9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_418",
    "data-name": "Caminho 418",
    d: "M4284.968,822.906a1.8,1.8,0,0,1-1.091-3.228l6.709-5.113a1.8,1.8,0,1,1,2.18,2.86l-6.708,5.113A1.79,1.79,0,0,1,4284.968,822.906Z",
    transform: "translate(-546.95 -312.239)",
    fill: "#037cf9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_419",
    "data-name": "Caminho 419",
    d: "M3600.16,1082.823a1.8,1.8,0,0,1-1.722-1.284c-1.4-4.7-2.28-13.147-2.317-13.5a1.8,1.8,0,1,1,3.577-.366c.009.084.878,8.464,2.185,12.841a1.8,1.8,0,0,1-1.724,2.313Z",
    transform: "translate(-24.603 -503.718)",
    fill: "#037cf9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_420",
    "data-name": "Caminho 420",
    d: "M3752.094,1361.331a1.793,1.793,0,0,1-.627-.113,113.77,113.77,0,0,1-47.173-33.233,1.8,1.8,0,0,1,2.749-2.319,110.163,110.163,0,0,0,45.678,32.181,1.8,1.8,0,0,1-.627,3.484Z",
    transform: "translate(-106.529 -700.607)",
    fill: "#037cf9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_421",
    "data-name": "Caminho 421",
    d: "M4235.812,1332.369a1.8,1.8,0,0,1-.674-3.466,109.718,109.718,0,0,0,49.461-39.734,1.8,1.8,0,1,1,2.963,2.037,113.3,113.3,0,0,1-51.078,41.032A1.791,1.791,0,0,1,4235.812,1332.369Z",
    transform: "translate(-509.578 -672.752)",
    fill: "#037cf9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_422",
    "data-name": "Caminho 422",
    d: "M4505.6,1002.1a1.8,1.8,0,0,1-1.715-2.34,109.786,109.786,0,0,0,5.07-33.08,110.891,110.891,0,0,0-1.581-18.668,1.8,1.8,0,0,1,3.545-.607,114.553,114.553,0,0,1,1.632,19.275,113.366,113.366,0,0,1-5.237,34.162A1.8,1.8,0,0,1,4505.6,1002.1Z",
    transform: "translate(-714.693 -412.374)",
    fill: "#037cf9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_423",
    "data-name": "Caminho 423",
    d: "M4477.538,819.64a1.8,1.8,0,0,1-1.637-1.052c-.756-1.656-1.564-3.315-2.4-4.931a1.8,1.8,0,0,1,3.192-1.656c.866,1.669,1.7,3.383,2.482,5.093a1.8,1.8,0,0,1-1.635,2.545Z",
    transform: "translate(-691.498 -309.832)",
    fill: "#037cf9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_424",
    "data-name": "Caminho 424",
    d: "M4371.765,516.544a1.8,1.8,0,0,1-1.375-2.956l9.791-11.629a1.8,1.8,0,1,1,2.75,2.316l-9.791,11.629A1.794,1.794,0,0,1,4371.765,516.544Z",
    transform: "translate(-612.941 -74.369)",
    fill: "#037cf9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_425",
    "data-name": "Caminho 425",
    d: "M3865.519,469.589a1.8,1.8,0,0,1-1.6-.971l-6.688-12.9a1.8,1.8,0,1,1,3.192-1.655l6.688,12.9a1.8,1.8,0,0,1-1.595,2.626Z",
    transform: "translate(-222.972 -37.702)",
    fill: "#037cf9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_426",
    "data-name": "Caminho 426",
    d: "M4221.917,673.368a8.129,8.129,0,0,1-8.121-8.12v-1.68a1.8,1.8,0,0,1,1.8-1.8h12.646a1.8,1.8,0,0,1,1.8,1.8v1.68A8.13,8.13,0,0,1,4221.917,673.368Zm-4.523-8a4.524,4.524,0,0,0,9.046,0Z",
    transform: "translate(-494.208 -196.353)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_427",
    "data-name": "Caminho 427",
    d: "M4204.54,626.022a1.8,1.8,0,0,1-1.8-1.8,1.041,1.041,0,1,0-2.082,0,1.8,1.8,0,0,1-3.6,0,4.637,4.637,0,1,1,9.274,0A1.8,1.8,0,0,1,4204.54,626.022Z",
    transform: "translate(-481.488 -164.284)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_428",
    "data-name": "Caminho 428",
    d: "M4265.416,626.022a1.8,1.8,0,0,1-1.8-1.8,1.041,1.041,0,1,0-2.082,0,1.8,1.8,0,1,1-3.6,0,4.637,4.637,0,1,1,9.273,0A1.8,1.8,0,0,1,4265.416,626.022Z",
    transform: "translate(-527.77 -164.284)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_291",
    "data-name": "Grupo 291",
    transform: "translate(3571.362 415.389)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_284",
    "data-name": "Grupo 284",
    transform: "translate(181.718 163.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_282",
    "data-name": "Grupo 282",
    transform: "translate(0 9.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_429",
    "data-name": "Caminho 429",
    d: "M4359.134,1177.6H4355.3a1.8,1.8,0,0,1,0-3.6h3.836a1.8,1.8,0,0,1,0,3.6Z",
    transform: "translate(-4353.5 -1174)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_430",
    "data-name": "Caminho 430",
    d: "M4419.613,1177.6H4415.3a1.8,1.8,0,1,1,0-3.6h4.315a1.8,1.8,0,1,1,0,3.6Z",
    transform: "translate(-4399.116 -1174)",
    fill: "#037cf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_283",
    "data-name": "Grupo 283",
    transform: "translate(9.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_431",
    "data-name": "Caminho 431",
    d: "M4393.8,1204.932a1.8,1.8,0,0,1-1.8-1.8V1199.3a1.8,1.8,0,0,1,3.6,0v3.836A1.8,1.8,0,0,1,4393.8,1204.932Z",
    transform: "translate(-4392 -1182.637)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_432",
    "data-name": "Caminho 432",
    d: "M4393.8,1143.411a1.8,1.8,0,0,1-1.8-1.8V1137.3a1.8,1.8,0,0,1,3.6,0v4.315A1.8,1.8,0,0,1,4393.8,1143.411Z",
    transform: "translate(-4392 -1135.5)",
    fill: "#037cf9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_287",
    "data-name": "Grupo 287",
    transform: "translate(102.606 239.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_285",
    "data-name": "Grupo 285",
    transform: "translate(0 9.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_433",
    "data-name": "Caminho 433",
    d: "M4029.134,1495.6H4025.3a1.8,1.8,0,0,1,0-3.6h3.836a1.8,1.8,0,0,1,0,3.6Z",
    transform: "translate(-4023.5 -1492)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_434",
    "data-name": "Caminho 434",
    d: "M4089.614,1495.6H4085.3a1.8,1.8,0,0,1,0-3.6h4.315a1.8,1.8,0,1,1,0,3.6Z",
    transform: "translate(-4069.116 -1492)",
    fill: "#037cf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_286",
    "data-name": "Grupo 286",
    transform: "translate(9.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_435",
    "data-name": "Caminho 435",
    d: "M4063.8,1522.932a1.8,1.8,0,0,1-1.8-1.8V1517.3a1.8,1.8,0,1,1,3.6,0v3.836A1.8,1.8,0,0,1,4063.8,1522.932Z",
    transform: "translate(-4062 -1500.637)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_436",
    "data-name": "Caminho 436",
    d: "M4063.8,1461.411a1.8,1.8,0,0,1-1.8-1.8V1455.3a1.8,1.8,0,1,1,3.6,0v4.315A1.8,1.8,0,0,1,4063.8,1461.411Z",
    transform: "translate(-4062 -1453.5)",
    fill: "#037cf9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_290",
    "data-name": "Grupo 290",
    transform: "translate(0 171.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_288",
    "data-name": "Grupo 288",
    transform: "translate(0 9.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_437",
    "data-name": "Caminho 437",
    d: "M3601.134,1212.6H3597.3a1.8,1.8,0,1,1,0-3.6h3.836a1.8,1.8,0,0,1,0,3.6Z",
    transform: "translate(-3595.5 -1209)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_438",
    "data-name": "Caminho 438",
    d: "M3661.613,1212.6H3657.3a1.8,1.8,0,0,1,0-3.6h4.315a1.8,1.8,0,0,1,0,3.6Z",
    transform: "translate(-3641.116 -1209)",
    fill: "#037cf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_289",
    "data-name": "Grupo 289",
    transform: "translate(9.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_439",
    "data-name": "Caminho 439",
    d: "M3635.8,1239.932a1.8,1.8,0,0,1-1.8-1.8V1234.3a1.8,1.8,0,0,1,3.6,0v3.836A1.8,1.8,0,0,1,3635.8,1239.932Z",
    transform: "translate(-3634 -1217.637)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_440",
    "data-name": "Caminho 440",
    d: "M3635.8,1178.411a1.8,1.8,0,0,1-1.8-1.8V1172.3a1.8,1.8,0,1,1,3.6,0v4.315A1.8,1.8,0,0,1,3635.8,1178.411Z",
    transform: "translate(-3634 -1170.5)",
    fill: "#037cf9"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_441",
    "data-name": "Caminho 441",
    d: "M4462.316,1221.968a5.828,5.828,0,1,1,5.828-5.828A5.835,5.835,0,0,1,4462.316,1221.968Zm0-8.059a2.232,2.232,0,1,0,2.232,2.232A2.234,2.234,0,0,0,4462.316,1213.909Z",
    transform: "translate(-4250.081 -1028.782)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_442",
    "data-name": "Caminho 442",
    d: "M4270.642,464.747a5.828,5.828,0,1,1,5.827-5.828A5.835,5.835,0,0,1,4270.642,464.747Zm0-8.059a2.232,2.232,0,1,0,2.231,2.232A2.234,2.234,0,0,0,4270.642,456.688Z",
    transform: "translate(-4104.357 -453.092)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_443",
    "data-name": "Caminho 443",
    d: "M3692.891,596.381a5.828,5.828,0,1,1,5.828-5.828A5.834,5.834,0,0,1,3692.891,596.381Zm0-8.059a2.232,2.232,0,1,0,2.232,2.232A2.234,2.234,0,0,0,3692.891,588.322Z",
    transform: "translate(-3665.112 -553.169)",
    fill: "#037cf9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_444",
    "data-name": "Caminho 444",
    d: "M3800.792,955.152a1.823,1.823,0,0,1-.216-.013l-11.992-1.438a1.8,1.8,0,0,1,.429-3.571L3801,951.569a1.8,1.8,0,0,1-.212,3.583Z",
    transform: "translate(-169.729 -415.576)",
    fill: "#037cf9",
    opacity: 0.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupo);
export default __webpack_public_path__ + "static/media/grupo.1138452d9371cbc34ff9db1f54ec9a42.svg";
export { ForwardRef as ReactComponent };